import router from '../../router/index.js';
import auth from '@/API/services/auth';
import miniToastr from 'mini-toastr';
import request from '@/API/';

const getDefaultState = () => {
  return {
    user: null,
    user_email: null,
    avatar: null,
    session_id: document.cookie.replace(/(?:(?:^|.*;\s*)session\s*=\s*([^;]*).*$)|^.*$/, '$1'),
    error: null,
    success: false,
    packagesList: null,
    registered: false,
    clients: [],
    invites: [],
    loggedIn: false,
  }
}// initial state
const state = getDefaultState()
const getters = {
  isLoggedIn: (state) => {
    return state.session_id ? true : false;
  },
  userClients: (state) => {
    return state.clients;
  },
  userBuildRights: (state) => c => {
//    console.log('clients:',state.clients)
    const client = state.clients.find(client => client.ID === c);
    return client?.build;
  },
  userAdminRights: (state) => c => {
    const client = state.clients.find(client => client.ID === c);
    return client?.admin;
  },
};

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  },
  LOGIN_REDIRECT: () => {
    sessionStorage.setItem('redirect', router.currentRoute.fullPath);
    router.push(`/pages/login`);
  },
  LOGIN: (state, payload) => {
    console.log('login payload', payload);
    sessionStorage.setItem('session', payload.session_id);
    state.session_id = payload.session_id;
    request.defaults.headers.Authorization = 'Bearer '+payload.session_id;
    state.loggedIn  = true;
    if(payload?.clients?.length) {
      state.clients = payload.clients;
    }

    const redirect = sessionStorage.getItem('redirect');
    if (redirect) {
      sessionStorage.removeItem('redirect');
      router.push(redirect);
      return;
    }

    if(payload?.clients?.length) {
      if (state.clients.length === 1) {
        router.push('/organisation-dashboard?c='+state.clients[0].ID);
      } else if (state.clients.length > 0) {
        router.push('/dashboard');
      }
    } else {
      router.push('/dashboard'); // Welcome "where to go"
    }
  },
  LOGOUT: () => {
    localStorage.removeItem('vuex');
    console.log('logout');
    sessionStorage.removeItem('session');
    state.session_id = '';
    sessionStorage.clear();
    router.push('/pages/login');
  },
  SET_ERROR: (state, payload) => {
    if(payload && payload.data) {
      state.error = payload.data.error
      miniToastr.error(payload.data.error, ' ' );
    } else {
      state.error = null
    }
  },
  SET_UCLIENTS: (state, payload) => {
    state.loggedIn  = true;
    state.clients = payload;
  },
  ADD_UCLIENT: (state, payload) => {
    state.clients.push(payload);
  },
  SET_SUCCESS: (state) => {
    state.success = true;
  },
  SET_REGISTERED: (state) => {
    state.registered = true;
  },
  SET_USER: (state, payload) => {
    state.user = payload;
  },
  SET_AVATAR: (state, payload) => {
    state.avatar = payload;
  },
  SET_INVITES: (state, payload) => {
    state.invites = payload;
  },
  SET_USER_EMAIL: (state, payload) => {
    state.user_email = payload;
  },
  SET_PACKAGES_LIST: (state, payload) => {
    state.packagesList = payload;
  },
};

const actions = {
  resetAuthState ({ commit }) {
    commit('RESET_STATE')
  },
  loginRedirect: ({ commit }) => {
    commit('LOGIN_REDIRECT');
  },
  login: async ({ commit }, payload) => {
    try {
      const { data } = await auth.login(payload);
      if (data.session_id) {
        commit('LOGIN', data);
        commit('SET_ERROR', null);
      } else {
        commit('SET_ERROR', data.error);
      }
    } catch (err) {
      commit('SET_ERROR', err);
    }
  },
  ssoLogin: async ({ commit }, data) => {
    console.log('ssoLogin', data);
    try {
      if (data.session_id) {
        commit('SET_UCLIENTS', data.clients);
        commit('SET_ERROR', null);
      } else {
        commit('SET_ERROR', data.error);
      }
    } catch (err) {
      commit('SET_ERROR', err);
    }
  },
  logout: ({ commit }) => {
    commit('LOGOUT');
  },
  fetchUser: async ({ commit }) => {
    try {
      const { data } = await auth.fetchUser();
      commit('SET_USER', data.username);
      commit('SET_USER_EMAIL', data.email);
      commit('SET_AVATAR', data.avatar);
      commit('SET_INVITES', data.invites);
    } catch (err) {
      console.log(err);
    }
  },
  forgotPassword: async ({ commit }, payload) => {
    try {
      await auth.remindPassword(payload);
      commit('SET_SUCCESS');
      router.push('/pages/login?section=reset-link-sent');
    } catch (err) {
      console.log(err);
      if (err.data != undefined) {
        console.log('error:',err.data.error);
        commit('SET_ERROR', err.data.error);
        return;
      }
      console.log(err.data);
      commit('SET_ERROR', err);
    }
  },
  fetchModulesPackages: async ({ commit }) => {
    try {
      const { data } = await auth.fetchPackagesList();
      commit('SET_PACKAGES_LIST', data);
    } catch (err) {
      console.log(err);
    }
  },
  createCheckout: async () => {
    try {
      // const { data } = await auth.createCheckoutSession(payload);
      // commit('SET_PACKAGES_LIST', data);
    } catch (err) {
      console.log(err);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
